import { faFileCsv } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ExportButton = ({ isLoading = false, label = 'Export', ...props }) => {
    return (
        <button
            type="button"
            className="btn btn-primary d-flex align-items-center"
            disabled={props.disabled || isLoading}
            {...props}
        >
            <FontAwesomeIcon icon={faFileCsv} className='me-1 mb-1' />
            {isLoading ? 'Exporting...' : label}
        </button>
    )
}

export default ExportButton